import React, { useState } from "react";
import LocationMap from "./Map";
import GarageModal from "./serviceItem/GarageModal";


export const RepairMaps = ({
  data,
  userLocation,
  mapLoading,
  addressHandler,
  setGaragesLoading,
  setMapLoading,
}) => {
  const [mapCordination, setMapCordination] = useState();
  const [showMap, setShowMap] = useState(false);
  const changeMap = (latlng) => {
    setMapCordination(latlng);
  };
  const handleShowmap = (condition) => {
    setShowMap(condition);
  };
  return (
    <div className="serviceMap">
      <LocationMap
        addressHandler={addressHandler}
        handleShowmap={() => handleShowmap()}
        changeMap={changeMap}
        userLocation={userLocation}
        data={data}
        mapLoading={mapLoading}
        setMapLoading={setMapLoading}
      />
      <GarageModal data={data} addressHandler={addressHandler} />
    </div>
  );
};
